import api from "./api";

// Capa de servicios API del dominio "prompt" (agentes IA: prompt + media + documentos + capas)
// (FSD / capa API transversal). Consolidado desde components/PromptModal/prompt.api.js.
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- CRUD ---
export const listPrompts = (params) => api.get("/prompt", { params });
export const getPrompt = (id) => api.get(`/prompt/${id}`);
export const createPrompt = (payload) => api.post("/prompt", payload);
export const updatePrompt = (id, payload) => api.put(`/prompt/${id}`, payload);
export const deletePrompt = (id) => api.delete(`/prompt/${id}`);
export const validatePromptApi = (payload) =>
  api.post("/prompt/validate-api", payload);

// --- Media ---
export const getPromptMedia = (id) => api.get(`/prompt/${id}/media`);
export const uploadPromptMedia = (id, formData, config) =>
  api.post(`/prompt/${id}/media`, formData, config);
export const deletePromptMedia = (id, mediaId) =>
  api.delete(`/prompt/${id}/media/${mediaId}`);
export const addPromptMediaUrl = (id, payload) =>
  api.post(`/prompt/${id}/media/url`, payload);

// --- Documentos ---
export const listPromptDocuments = (promptId) =>
  api.get(`/prompt/${promptId}/documents`);
export const uploadPromptDocument = (promptId, formData) =>
  api.post(`/prompt/${promptId}/documents`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
export const deletePromptDocument = (promptId, documentId) =>
  api.delete(`/prompt/${promptId}/documents/${documentId}`);

// --- Capas ---
export const listPromptLayers = (promptId) =>
  api.get(`/prompt/${promptId}/layers`);
export const createPromptLayer = (promptId, formData) =>
  api.post(`/prompt/${promptId}/layers`, formData);
export const updatePromptLayer = (promptId, layerId, formData) =>
  api.put(`/prompt/${promptId}/layers/${layerId}`, formData);
export const deletePromptLayer = (promptId, layerId) =>
  api.delete(`/prompt/${promptId}/layers/${layerId}`);
